



























































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";
import { swiper, swiperSlide } from "vue-awesome-swiper";

@Component({
  components: {
    swiper,
    swiperSlide
  }
})
export default class PreResources extends Vue {
  private fields = [{ key: "title" }, "download"];
  private subjectSelected = -1;
  private filter = "";
  private auth = new AuthService();
  private isPre2 = false;

  private downloadResource(item) {
    window.open(item.download, "_blank");
  }

  private rowClass(item, type) {
    if (!item || type !== "row") return;

    return "cursor-pointer";
  }

  getImgUrl(pet) {
    if (pet[pet.length - 1] == ' ') {
        pet = pet.substring(0, pet.length-1);
    }
    const images = require.context("../assets/images/books/", false, /\.jpg$/);
    try {
      return images("./" + pet + ".jpg");
    } catch {
      // return images('./error.png')
    }
  }

  swiperOptionVideo = {
    slidesPerView: 3,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    keyboard: {
      enabled: true
    },
    breakpoints: {
      // when window width is <= 640px
      640: {
        slidesPerView: 1
      },
      1000: {
        slidesPerView: 2
      }
    }
  };

  mounted() {
    if (
      localStorage[config.classLevl] !== "null" &&
      localStorage[config.classLevl] !== "undefined"
    ) {
      if (
        localStorage[config.classLevl] == "8aa08620-cab9-44f4-b884-d24f0951ef62"
      ) {
        this.subjectSelected = 0;
      } else if (
        localStorage[config.classLevl] == "fc27bb7a-989c-4174-9822-7686fb965a0f"
      ) {
        this.subjectSelected = 1;
      } else if (
        localStorage[config.classLevl] == "3d0de5a2-cd6d-4b25-80a2-1b00473cfc5a"
      ) {
        this.subjectSelected = 2;
      } else if (
        localStorage[config.classLevl] == "b08cbe37-93dd-4b67-8e64-7d80a0347740"
      ) {
        this.subjectSelected = 3;
      } else if (
        localStorage[config.classLevl] == "8aa08620-cab4-44f4-b884-d24f0951ef62" // F.Sc (E) - (F.B)
      ) {
        this.subjectSelected = 4;
      } else if (
        localStorage[config.classLevl] == "fc27bb7a-989a-4174-9822-7686fb965a0f" // F.Sc (M) - (F.B)
      ) {
        this.subjectSelected = 5;
      } else if (
        localStorage[config.classLevl] == "3d0de5a2-cd6a-4b25-80a2-1b00473cfc5a" // I.Com - (F.B)
      ) {
        this.subjectSelected = 6;
      } else if (
        localStorage[config.classLevl] == "b08cbe37-93db-4b67-8e64-7d80a0347740" // I.Cs - (F.B)
      ) {
        this.subjectSelected = 7;
      }
    } else {
      alert("You need to select your program first!");
      this.$router.push("pre-module");
    }

    if (localStorage[config.isPre2] && localStorage[config.isPre2] !== undefined)
      this.isPre2 = JSON.parse(localStorage[config.isPre2])
  }

  private books = [
    [
      {
        title: "Chemistry",
        data: [
          {
            title: "Basic Concepts",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Basic Concepts.pdf?sp=r&st=2020-04-14T20:16:08Z&se=2023-04-15T20:16:00Z&sv=2019-02-02&sig=vzRFL8D5gjw4zAfEzluC955bgioFKKAy3LnSELFmbkQ%3D&sr=f"
          },
          {
            title: "Experimental Techniques",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Experimental Techniques in Chemistry.pdf?sp=r&st=2020-04-14T20:16:27Z&se=2025-04-15T20:16:00Z&sv=2019-02-02&sig=MoQ8qH3BeCT0JrcgkcRpiZ0MFTUPNAxyA%2F2AWGRq1kk%3D&sr=f"
          },
          {
            title: "Gases",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Gases.pdf?sp=r&st=2020-04-14T20:16:42Z&se=2025-04-15T20:16:00Z&sv=2019-02-02&sig=Af%2FLaKfQ%2BgEIUCWOKDLYDqdCaZmFsblqm0Po8Hq6c3A%3D&sr=f"
          }
        ]
      },

      {
        title: "Mathematics",
        data: [
          {
            title: "Matrices and Determinants",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Matrices & Determinant.pdf?sp=r&st=2020-04-14T20:24:43Z&se=2025-04-15T20:24:00Z&sv=2019-02-02&sig=UOaWrnDaLT4Ga7AaPCLTWb3PIuJgtMhXSnNq3uzCSQU%3D&sr=f"
          },
          {
            title: "Quadratic Equations",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Quadratic Equations.pdf?sp=r&st=2020-04-14T20:25:14Z&se=2026-04-15T20:25:00Z&sv=2019-02-02&sig=ZQ1pqIm3PTjyVCRKyx3eYCG98PQdl36yrzu8Y3JyFIw%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Applications",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Applications.pdf?sp=r&st=2020-04-14T20:31:30Z&se=2026-04-15T20:31:00Z&sv=2019-02-02&sig=iHsjvo5tSVgNdY1vIehhtOOoor%2F6YB2ChgCuq60elSI%3D&sr=f"
          },
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Lessons.pdf?sp=r&st=2020-04-14T20:31:50Z&se=2025-04-15T20:31:00Z&sv=2019-02-02&sig=eNzKGzQvvzpBHpWRelRF9eNFYZp2EshVNKkXeyF9oKA%3D&sr=f"
          },
          {
            title: "Letters",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Letters.pdf?sp=r&st=2020-04-14T20:32:08Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=%2FqzuHnEvgMp1Dqoe7DM%2FdXI13xL8r48tWOsWuNXZu3g%3D&sr=f"
          },
          {
            title: "Moral Stories",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Moral Stories.pdf?sp=r&st=2020-04-14T20:32:25Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=gp%2F7LhAxVTZkVQ36BsHmmfyWVMSUSSzRTPLKsDniq14%3D&sr=f"
          },
          {
            title: "Pair of Words",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Pair of Words.pdf?sp=r&st=2020-04-14T20:32:39Z&se=2024-04-15T20:32:00Z&sv=2019-02-02&sig=BUpHsCufR%2B8xCEZyy%2ByAGOjE27q2bJRNRuJhfgN4BqQ%3D&sr=f"
          },
          {
            title: "Plays",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Play.pdf?sp=r&st=2020-04-14T20:32:52Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=MCP0Rl%2F9P%2BLDmXLeKOJFwfw5Csy18hcDtGyZGCEhihs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Poems.pdf?sp=r&st=2020-04-14T20:33:06Z&se=2025-04-15T20:33:00Z&sv=2019-02-02&sig=mG245%2BHy%2BzW8A3Ud%2B1RwcMjUg5pXfCVwcmJnrIBf1S8%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Ghazals",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Ghazal.pdf?sp=r&st=2020-04-14T20:36:30Z&se=2025-04-15T20:36:00Z&sv=2019-02-02&sig=Ep53s79hy8BnyOTlPj8vyMZzFRgbYCXeC4RrH8f3qt0%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Grammar.pdf?sp=r&st=2020-04-14T20:37:12Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=HkwSu0IpiONvTsyNFVQP8M%2FrG2IykWP6mi9Fr0bw7y8%3D&sr=f"
          },
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nasar.pdf?sp=r&st=2020-04-14T20:37:26Z&se=2026-04-15T20:37:00Z&sv=2019-02-02&sig=MoeIJYESxmt9xzwC8iz%2FvVXmm3WL2aEydBIEcQpoJrs%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nazam.pdf?sp=r&st=2020-04-14T20:37:45Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=vNGqqbqOp0Y5k%2FtQcHRgmfmNsIQ4eJel8DHSPh62uZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Measurements.pdf?sp=r&st=2020-04-15T13:32:06Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=%2BWCYCD%2BGieCbFXy2sW2OgHmoeFOTFNlH3DGBv1J0sPk%3D&sr=f"
          },
          {
            title: "Vectors and Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Vectors and Equilibrium.pdf?sp=r&st=2020-04-15T13:32:54Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=sNgJpanzLvGHfARqagYTztBbdpxi4STZ9UeYbbn%2F9%2Bc%3D&sr=f"
          },
          {
            title: "Motion and Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Motion & Force.pdf?sp=r&st=2020-04-15T21:08:29Z&se=2027-04-16T21:08:00Z&sv=2019-02-02&sig=cRHyhWFNocEi5aRc1qnuKqDVzjNKhbxIZ3XjUDeABM0%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Chemistry",
        data: [
          {
            title: "Basic Concepts",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Basic Concepts.pdf?sp=r&st=2020-04-14T20:16:08Z&se=2023-04-15T20:16:00Z&sv=2019-02-02&sig=vzRFL8D5gjw4zAfEzluC955bgioFKKAy3LnSELFmbkQ%3D&sr=f"
          },
          {
            title: "Experimental Techniques",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Experimental Techniques in Chemistry.pdf?sp=r&st=2020-04-14T20:16:27Z&se=2025-04-15T20:16:00Z&sv=2019-02-02&sig=MoQ8qH3BeCT0JrcgkcRpiZ0MFTUPNAxyA%2F2AWGRq1kk%3D&sr=f"
          },
          {
            title: "Gases",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Gases.pdf?sp=r&st=2020-04-14T20:16:42Z&se=2025-04-15T20:16:00Z&sv=2019-02-02&sig=Af%2FLaKfQ%2BgEIUCWOKDLYDqdCaZmFsblqm0Po8Hq6c3A%3D&sr=f"
          }
        ]
      },
      {
        title: "Biology",
        data: [
          {
            title: "Introduction",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-MEDICAL/Introduction.pdf?sp=r&st=2020-04-14T20:57:40Z&se=2026-04-15T20:57:00Z&sv=2019-02-02&sig=VzQiLGrroycGlOO1xgIV4tivGfZO57u91AbzRG4t%2B%2Fs%3D&sr=f"
          },
          {
            title: "Enzymes",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-MEDICAL/Enzymes.pdf?sp=r&st=2020-04-14T20:57:27Z&se=2025-04-15T20:57:00Z&sv=2019-02-02&sig=pGXJIJv5kvMVm1ux2exicCHsy2VYeBOv3BqeDyWeUmQ%3D&sr=f"
          },
          {
            title: "The Cell",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-MEDICAL/The Cell.pdf?sp=r&st=2020-04-14T20:58:50Z&se=2026-04-15T20:58:00Z&sv=2019-02-02&sig=Ol3CCC7qKJtorLvGgxz5B9zCWSq9Qn5oV2Vso5%2FPwu8%3D&sr=f"
          },
          {
            title: "Variety of Life",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-MEDICAL/Variety of life.pdf?sp=r&st=2020-04-14T21:01:23Z&se=2025-04-15T21:01:00Z&sv=2019-02-02&sig=cgQsZ4uctfNfKMfLKw%2FwBMY79GjI%2FRtIJ3lRs3UfNrg%3D&sr=f"
          },
          {
            title: "Kingdom Prokaryotae",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-MEDICAL/kingdom prokaryotae (monera).pdf?sp=r&st=2020-04-14T21:01:46Z&se=2025-04-15T21:01:00Z&sv=2019-02-02&sig=MZUeJ9L9zHxEqUhSYMTjGqbMoIuWr6ebmENvy45rq1Q%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Applications",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Applications.pdf?sp=r&st=2020-04-14T20:31:30Z&se=2026-04-15T20:31:00Z&sv=2019-02-02&sig=iHsjvo5tSVgNdY1vIehhtOOoor%2F6YB2ChgCuq60elSI%3D&sr=f"
          },
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Lessons.pdf?sp=r&st=2020-04-14T20:31:50Z&se=2025-04-15T20:31:00Z&sv=2019-02-02&sig=eNzKGzQvvzpBHpWRelRF9eNFYZp2EshVNKkXeyF9oKA%3D&sr=f"
          },
          {
            title: "Letters",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Letters.pdf?sp=r&st=2020-04-14T20:32:08Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=%2FqzuHnEvgMp1Dqoe7DM%2FdXI13xL8r48tWOsWuNXZu3g%3D&sr=f"
          },
          {
            title: "Moral Stories",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Moral Stories.pdf?sp=r&st=2020-04-14T20:32:25Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=gp%2F7LhAxVTZkVQ36BsHmmfyWVMSUSSzRTPLKsDniq14%3D&sr=f"
          },
          {
            title: "Pair of Words",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Pair of Words.pdf?sp=r&st=2020-04-14T20:32:39Z&se=2024-04-15T20:32:00Z&sv=2019-02-02&sig=BUpHsCufR%2B8xCEZyy%2ByAGOjE27q2bJRNRuJhfgN4BqQ%3D&sr=f"
          },
          {
            title: "Plays",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Play.pdf?sp=r&st=2020-04-14T20:32:52Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=MCP0Rl%2F9P%2BLDmXLeKOJFwfw5Csy18hcDtGyZGCEhihs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Poems.pdf?sp=r&st=2020-04-14T20:33:06Z&se=2025-04-15T20:33:00Z&sv=2019-02-02&sig=mG245%2BHy%2BzW8A3Ud%2B1RwcMjUg5pXfCVwcmJnrIBf1S8%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Ghazals",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Ghazal.pdf?sp=r&st=2020-04-14T20:36:30Z&se=2025-04-15T20:36:00Z&sv=2019-02-02&sig=Ep53s79hy8BnyOTlPj8vyMZzFRgbYCXeC4RrH8f3qt0%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Grammar.pdf?sp=r&st=2020-04-14T20:37:12Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=HkwSu0IpiONvTsyNFVQP8M%2FrG2IykWP6mi9Fr0bw7y8%3D&sr=f"
          },
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nasar.pdf?sp=r&st=2020-04-14T20:37:26Z&se=2026-04-15T20:37:00Z&sv=2019-02-02&sig=MoeIJYESxmt9xzwC8iz%2FvVXmm3WL2aEydBIEcQpoJrs%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nazam.pdf?sp=r&st=2020-04-14T20:37:45Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=vNGqqbqOp0Y5k%2FtQcHRgmfmNsIQ4eJel8DHSPh62uZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Measurements.pdf?sp=r&st=2020-04-15T13:32:06Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=%2BWCYCD%2BGieCbFXy2sW2OgHmoeFOTFNlH3DGBv1J0sPk%3D&sr=f"
          },
          {
            title: "Vectors and Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Vectors and Equilibrium.pdf?sp=r&st=2020-04-15T13:32:54Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=sNgJpanzLvGHfARqagYTztBbdpxi4STZ9UeYbbn%2F9%2Bc%3D&sr=f"
          },
          {
            title: "Motion and Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Motion & Force.pdf?sp=r&st=2020-04-15T21:08:29Z&se=2027-04-16T21:08:00Z&sv=2019-02-02&sig=cRHyhWFNocEi5aRc1qnuKqDVzjNKhbxIZ3XjUDeABM0%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Business Mathematics",
        data: [
          {
            title: "Amount of Annuity",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Amount of annuity.pdf?sp=r&st=2020-04-14T21:15:14Z&se=2025-04-15T21:15:00Z&sv=2019-02-02&sig=975rk4DpwHs0gF0LceTQUeSadjlRgUY3wKaq1tXqaOY%3D&sr=f"
          },
          {
            title: "Binary Number System",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Binary number system & its operation.pdf?sp=r&st=2020-04-14T21:17:40Z&se=2024-04-15T21:17:00Z&sv=2019-02-02&sig=9HLgW3IcNs%2FylsfQt0LWlOrLRj3Ra0tjThLnh7S12H8%3D&sr=f"
          },
          {
            title: "Business Arithmetic",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Business Arithmetic.pdf?sp=r&st=2020-04-14T21:18:45Z&se=2025-04-15T21:18:00Z&sv=2019-02-02&sig=eY%2BZbRqBfM49z7KIsQOZ5fUloj3IsZKYDazxVM9EVJs%3D&sr=f"
          },
          {
            title: "Elements of Matrix Algebra",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Elements of Matrix Algebra.pdf?sp=r&st=2020-04-14T21:50:01Z&se=2025-04-15T21:50:00Z&sv=2019-02-02&sig=bnFS8I0PSc0o%2B7o7pIqtlIKJzgleDA0bfQXg9CrhfZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Economics Urdu Medium",
        data: [
          {
            title: "Nature and Scope of Economics",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Nature and Scope of Economics.pdf?sp=r&st=2020-04-14T22:03:39Z&se=2025-04-15T22:03:00Z&sv=2019-02-02&sig=5kOkdl5N8%2BnrW%2FfpepiWtKK91vhWlMk9vVwKjGVBvRk%3D&sr=f"
          },
          {
            title: "Consumer Behaviour",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Consumer Behaviour.pdf?sp=r&st=2020-04-14T21:57:01Z&se=2024-04-15T21:57:00Z&sv=2019-02-02&sig=bpCtUxIi1GsYghCsdG%2BNm3GXCL4c73HHYaIlluzARzQ%3D&sr=f"
          },
          {
            title: "Demand",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Demand.pdf?sp=r&st=2020-04-14T21:57:20Z&se=2024-04-15T21:57:00Z&sv=2019-02-02&sig=rYRNCerTUr%2F9X4ki4zWdDc1QXEx0V3YfkxPesvjKq%2FY%3D&sr=f"
          },
          {
            title: "Supply",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Supply.pdf?sp=r&st=2020-04-14T22:04:41Z&se=2025-04-15T22:04:00Z&sv=2019-02-02&sig=h4ntfo2VwnVchF%2BqSpmL%2Bpz1%2BIZabDbZzklJ8ngL1Cw%3D&sr=f"
          },
          {
            title: "Market Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Market Equilibrium.pdf?sp=r&st=2020-04-14T22:03:12Z&se=2025-04-15T22:03:00Z&sv=2019-02-02&sig=cA41papfx1lD4JEXb8SLjF%2FxlQTcpRrQr7wqckwZmJg%3D&sr=f"
          },
          {
            title: "Production and Factors of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Production and Factors of Production.pdf?sp=r&st=2020-04-14T22:04:29Z&se=2025-04-15T22:04:00Z&sv=2019-02-02&sig=DWwXwtBz2siOYzusLE2wtJsLO%2Bqz1BX8oy0udrTuST4%3D&sr=f"
          },
          {
            title: "Laws of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Laws of Production.pdf?sp=r&st=2020-04-14T21:59:50Z&se=2024-04-15T21:59:00Z&sv=2019-02-02&sig=8K7wxTJ9gQGUJz1acbDdKZG3UDBNehBoQEPNLh%2BRGkA%3D&sr=f"
          },
          {
            title: "National Income and Public Finance",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-National Income & Public Finance.pdf?sp=r&st=2020-04-14T22:03:26Z&se=2024-04-15T22:03:00Z&sv=2019-02-02&sig=fwk8scnWXjE%2BdCzECXChfKq9pRkOyg2SFIMbYiIvyHA%3D&sr=f"
          }
        ]
      },
      {
        title: "Economics English Medium",
        data: [
          {
            title: "Nature and Scope of Economics",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Nature-and-Scope-of-Economics.pdf?sp=r&st=2020-04-14T21:51:28Z&se=2024-04-15T21:51:00Z&sv=2019-02-02&sig=F8GtKqOOPGuGoTmAUnAL8IL7yAg%2BzboJSbvM9yJh%2Fjk%3D&sr=f"
          },
          {
            title: "Consumer Behaviour",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Consumer-Behaviour.pdf?sp=r&st=2020-04-14T21:49:11Z&se=2026-04-15T21:49:00Z&sv=2019-02-02&sig=MmS0biFpvPTNE1G46Sn8u1a%2Fh%2FM%2FFfsK62QEhBTVUJk%3D&sr=f"
          },
          {
            title: "Demand",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Demand.pdf?sp=r&st=2020-04-14T21:49:45Z&se=2025-04-15T21:49:00Z&sv=2019-02-02&sig=3HLXdTLOSMFCHzX8iCEkSq%2FFi%2Fi0qk7WfHoxvxvqGZ8%3D&sr=f"
          },
          {
            title: "Supply",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Supply.pdf?sp=r&st=2020-04-14T21:52:09Z&se=2025-04-15T21:52:00Z&sv=2019-02-02&sig=YePLOeGZ9hLNEBGTsJUwqtK4VprxkKlU%2FCty2N4AUHE%3D&sr=f"
          },
          {
            title: "Market Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Market-Equilibrium.pdf?sp=r&st=2020-04-14T21:51:03Z&se=2024-04-15T21:51:00Z&sv=2019-02-02&sig=dq6HQQ9r9%2B1%2BR0lRHxjvBeuKc56LOUnwzDWJAQXY%2BGo%3D&sr=f"
          },
          {
            title: "Production and Factors of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Production and Factors of Production.pdf?sp=r&st=2020-04-14T21:51:42Z&se=2025-04-15T21:51:00Z&sv=2019-02-02&sig=ngCZ4of5tEicKfR3mrKV%2F9ozLNYcBe3iX3LPNicD3Ik%3D&sr=f"
          },
          {
            title: "Laws of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Laws of Production.pdf?sp=r&st=2020-04-14T21:50:34Z&se=2025-04-15T21:50:00Z&sv=2019-02-02&sig=X42yY%2FeOiHW807R%2BTkPSRcbcDsm8xhX42Y5ATRd1ReE%3D&sr=f"
          },
          {
            title: "National Income and Public Finance",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/National Income & Public Finance.pdf?sp=r&st=2020-04-14T21:51:15Z&se=2025-04-15T21:51:00Z&sv=2019-02-02&sig=YKmmRAYXQrWXOTx2K%2BoPYJ%2Bw9P66NSHmDTJhEXT0dGw%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Applications",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Applications.pdf?sp=r&st=2020-04-14T20:31:30Z&se=2026-04-15T20:31:00Z&sv=2019-02-02&sig=iHsjvo5tSVgNdY1vIehhtOOoor%2F6YB2ChgCuq60elSI%3D&sr=f"
          },
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Lessons.pdf?sp=r&st=2020-04-14T20:31:50Z&se=2025-04-15T20:31:00Z&sv=2019-02-02&sig=eNzKGzQvvzpBHpWRelRF9eNFYZp2EshVNKkXeyF9oKA%3D&sr=f"
          },
          {
            title: "Letters",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Letters.pdf?sp=r&st=2020-04-14T20:32:08Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=%2FqzuHnEvgMp1Dqoe7DM%2FdXI13xL8r48tWOsWuNXZu3g%3D&sr=f"
          },
          {
            title: "Moral Stories",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Moral Stories.pdf?sp=r&st=2020-04-14T20:32:25Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=gp%2F7LhAxVTZkVQ36BsHmmfyWVMSUSSzRTPLKsDniq14%3D&sr=f"
          },
          {
            title: "Pair of Words",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Pair of Words.pdf?sp=r&st=2020-04-14T20:32:39Z&se=2024-04-15T20:32:00Z&sv=2019-02-02&sig=BUpHsCufR%2B8xCEZyy%2ByAGOjE27q2bJRNRuJhfgN4BqQ%3D&sr=f"
          },
          {
            title: "Plays",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Play.pdf?sp=r&st=2020-04-14T20:32:52Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=MCP0Rl%2F9P%2BLDmXLeKOJFwfw5Csy18hcDtGyZGCEhihs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Poems.pdf?sp=r&st=2020-04-14T20:33:06Z&se=2025-04-15T20:33:00Z&sv=2019-02-02&sig=mG245%2BHy%2BzW8A3Ud%2B1RwcMjUg5pXfCVwcmJnrIBf1S8%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Ghazals",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Ghazal.pdf?sp=r&st=2020-04-14T20:36:30Z&se=2025-04-15T20:36:00Z&sv=2019-02-02&sig=Ep53s79hy8BnyOTlPj8vyMZzFRgbYCXeC4RrH8f3qt0%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Grammar.pdf?sp=r&st=2020-04-14T20:37:12Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=HkwSu0IpiONvTsyNFVQP8M%2FrG2IykWP6mi9Fr0bw7y8%3D&sr=f"
          },
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nasar.pdf?sp=r&st=2020-04-14T20:37:26Z&se=2026-04-15T20:37:00Z&sv=2019-02-02&sig=MoeIJYESxmt9xzwC8iz%2FvVXmm3WL2aEydBIEcQpoJrs%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nazam.pdf?sp=r&st=2020-04-14T20:37:45Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=vNGqqbqOp0Y5k%2FtQcHRgmfmNsIQ4eJel8DHSPh62uZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Accounting",
        data: [
          {
            title: "Introduction",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Introduction.pdf?sp=r&st=2020-04-15T13:55:52Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=H6JgdD45icDiQUc64vSaJ0bblghP4sQuqIfXNik35Bc%3D&sr=f"
          },
          {
            title: "Transactions and Accounting Equation",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Transactions.pdf?sp=r&st=2020-04-15T13:56:31Z&se=2024-04-16T13:56:00Z&sv=2019-02-02&sig=HdkpUCih3F73ZKbtkllTLDa43Pv6ZTi4Qc8Z0zw%2BSfU%3D&sr=f"
          },
          {
            title: "Analysis of Business Transactions & Double Entry System",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Double Entry.pdf?sp=r&st=2020-04-15T13:55:39Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=qERvTI%2BxnEb2Ruw0cecpff75kvg0vjw%2BvbMHWLFVxZ4%3D&sr=f"
          },
          {
            title: "Journal",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Journal.pdf?sp=r&st=2020-04-15T13:56:05Z&se=2025-04-16T13:56:00Z&sv=2019-02-02&sig=ZNhKw4t9ir8UpcKSOedPmqdPy2MmPTes7zyf57%2BP4EA%3D&sr=f"
          },
          {
            title: "Ledger",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Ledgar.pdf?sp=r&st=2020-04-15T13:56:17Z&se=2025-04-16T13:56:00Z&sv=2019-02-02&sig=M%2BSXwSu84AV5jdE3njOjmI2EIPbw2CEHf9bZPru4U9A%3D&sr=f"
          },
          {
            title: "Cash Book & Bank Reconciliation Statement",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Cash Book.pdf?sp=r&st=2020-04-15T13:55:24Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=SQ7x2bcxHq5XH4u86NRyKRyrwcqrtRRZ8snSboeEi6c%3D&sr=f"
          }
        ]
      },
      {
        title: "Commerce English Medium",
        data: [
          {
            title: "Concept of Business",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Concept of Business.pdf?sp=r&st=2020-04-15T14:33:20Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=JA7RjuKnrILDrpLgwVLgOUyVly0x0jVkG8FDkGgKD24%3D&sr=f"
          },
          {
            title: "Nature & Scope of Commerce",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Nature And Scope.pdf?sp=r&st=2020-04-15T14:33:54Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=2gsRBcifvMWvfmHNSh6WIcbKupQprVSiqiOXP8qED84%3D&sr=f"
          },
          {
            title: "Sole Tradership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Sole Tradership.pdf?sp=r&st=2020-04-15T14:34:19Z&se=2024-04-16T14:34:00Z&sv=2019-02-02&sig=o8qDWH38lA%2FvHlvzxihdOxVYKc20IMSumC%2BTpVG5JeM%3D&sr=f"
          },
          {
            title: "Partnership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Partnership.pdf?sp=r&st=2020-04-15T14:34:07Z&se=2024-04-16T14:34:00Z&sv=2019-02-02&sig=xcQD3QgAFa9C2EwUR6RsiWR1K8NJEL3oZn8Bx2K67%2BU%3D&sr=f"
          },
          {
            title: "Joint Stock Company",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Joint Stock Company.pdf?sp=r&st=2020-04-15T14:33:40Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=3tO54hUfEExlx0rXS2CxraKGyHzpW0vdTR40khUPN4M%3D&sr=f"
          },
          {
            title: "Concept of Business",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Concept of Business.pdf?sp=r&st=2020-04-15T14:35:41Z&se=2024-04-16T14:35:00Z&sv=2019-02-02&sig=R4%2BpQQxwG3FOU7KTxWKmyvkfD5siFd2S%2FikJnKZpOP4%3D&sr=f"
          },
          {
            title: "Nature & Scope of Commerce",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Nature and Scope of Commerce.pdf?sp=r&st=2020-04-15T14:36:11Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=6qV1JPCDe%2BC490GMYqKU43fl7YXb38EIZyo5NmVkjeQ%3D&sr=f"
          },
          {
            title: "Sole Tradership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Sole Tradership.pdf?sp=r&st=2020-04-15T14:36:34Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=TDw9JDr5s1DHz8aO0fearUjqto1h7pmYNpY5AqNUsbA%3D&sr=f"
          },
          {
            title: "Partnership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Partnership.pdf?sp=r&st=2020-04-15T14:36:22Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=gRfT6ZlCWbGJTD0H2WrBOn3DvmPfQNVvg%2FWzYKbw1sA%3D&sr=f"
          },
          {
            title: "Joint Stock Company",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Joint Stock Company.pdf?sp=r&st=2020-04-15T14:35:55Z&se=2023-04-16T14:35:00Z&sv=2019-02-02&sig=Hr4HwIp3wK4N7FP4GzGtIP%2BL%2BrQ62SuQX7cygirTvxw%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Mathematics",
        data: [
          {
            title: "Matrices and Determinants",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Matrices & Determinant.pdf?sp=r&st=2020-04-14T20:24:43Z&se=2025-04-15T20:24:00Z&sv=2019-02-02&sig=UOaWrnDaLT4Ga7AaPCLTWb3PIuJgtMhXSnNq3uzCSQU%3D&sr=f"
          },
          {
            title: "Quadratic Equations",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Quadratic Equations.pdf?sp=r&st=2020-04-14T20:25:14Z&se=2026-04-15T20:25:00Z&sv=2019-02-02&sig=ZQ1pqIm3PTjyVCRKyx3eYCG98PQdl36yrzu8Y3JyFIw%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Applications",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Applications.pdf?sp=r&st=2020-04-14T20:31:30Z&se=2026-04-15T20:31:00Z&sv=2019-02-02&sig=iHsjvo5tSVgNdY1vIehhtOOoor%2F6YB2ChgCuq60elSI%3D&sr=f"
          },
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Lessons.pdf?sp=r&st=2020-04-14T20:31:50Z&se=2025-04-15T20:31:00Z&sv=2019-02-02&sig=eNzKGzQvvzpBHpWRelRF9eNFYZp2EshVNKkXeyF9oKA%3D&sr=f"
          },
          {
            title: "Letters",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Letters.pdf?sp=r&st=2020-04-14T20:32:08Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=%2FqzuHnEvgMp1Dqoe7DM%2FdXI13xL8r48tWOsWuNXZu3g%3D&sr=f"
          },
          {
            title: "Moral Stories",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Moral Stories.pdf?sp=r&st=2020-04-14T20:32:25Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=gp%2F7LhAxVTZkVQ36BsHmmfyWVMSUSSzRTPLKsDniq14%3D&sr=f"
          },
          {
            title: "Pair of Words",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Pair of Words.pdf?sp=r&st=2020-04-14T20:32:39Z&se=2024-04-15T20:32:00Z&sv=2019-02-02&sig=BUpHsCufR%2B8xCEZyy%2ByAGOjE27q2bJRNRuJhfgN4BqQ%3D&sr=f"
          },
          {
            title: "Plays",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Play.pdf?sp=r&st=2020-04-14T20:32:52Z&se=2025-04-15T20:32:00Z&sv=2019-02-02&sig=MCP0Rl%2F9P%2BLDmXLeKOJFwfw5Csy18hcDtGyZGCEhihs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/English/Poems.pdf?sp=r&st=2020-04-14T20:33:06Z&se=2025-04-15T20:33:00Z&sv=2019-02-02&sig=mG245%2BHy%2BzW8A3Ud%2B1RwcMjUg5pXfCVwcmJnrIBf1S8%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Ghazals",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Ghazal.pdf?sp=r&st=2020-04-14T20:36:30Z&se=2025-04-15T20:36:00Z&sv=2019-02-02&sig=Ep53s79hy8BnyOTlPj8vyMZzFRgbYCXeC4RrH8f3qt0%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Grammar.pdf?sp=r&st=2020-04-14T20:37:12Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=HkwSu0IpiONvTsyNFVQP8M%2FrG2IykWP6mi9Fr0bw7y8%3D&sr=f"
          },
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nasar.pdf?sp=r&st=2020-04-14T20:37:26Z&se=2026-04-15T20:37:00Z&sv=2019-02-02&sig=MoeIJYESxmt9xzwC8iz%2FvVXmm3WL2aEydBIEcQpoJrs%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Urdu/Nazam.pdf?sp=r&st=2020-04-14T20:37:45Z&se=2027-04-15T20:37:00Z&sv=2019-02-02&sig=vNGqqbqOp0Y5k%2FtQcHRgmfmNsIQ4eJel8DHSPh62uZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Measurements.pdf?sp=r&st=2020-04-15T13:32:06Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=%2BWCYCD%2BGieCbFXy2sW2OgHmoeFOTFNlH3DGBv1J0sPk%3D&sr=f"
          },
          {
            title: "Vectors and Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Vectors and Equilibrium.pdf?sp=r&st=2020-04-15T13:32:54Z&se=2025-04-16T13:32:00Z&sv=2019-02-02&sig=sNgJpanzLvGHfARqagYTztBbdpxi4STZ9UeYbbn%2F9%2Bc%3D&sr=f"
          },
          {
            title: "Motion and Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Motion & Force.pdf?sp=r&st=2020-04-15T21:08:29Z&se=2027-04-16T21:08:00Z&sv=2019-02-02&sig=cRHyhWFNocEi5aRc1qnuKqDVzjNKhbxIZ3XjUDeABM0%3D&sr=f"
          }
        ]
      },
      {
        title: "Statistics",
        data: [
          {
            title: "Introdcution",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Introduction to Statistics.pdf?sp=r&st=2020-04-15T14:45:13Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=xlvPbj8rL%2BcAtOPK%2BNstOBmnEqeqGmOo2K42bQfI1Uk%3D&sr=f"
          },
          {
            title: "Presentation of Data",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Presentation of Data.pdf?sp=r&st=2020-04-15T14:45:55Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=DOZADGT5V2Ku4xKlZlHfUnCgWq0K5OriaLTQ1eb1cYc%3D&sr=f"
          },
          {
            title: "Measures of Location",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Measures of Location.pdf?sp=r&st=2020-04-15T14:45:42Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=S7MJgt9v0bwrxx8JveqWlXXV%2B7e1c%2FkkS0ezDwfrXFc%3D&sr=f"
          },
          {
            title: "Measures of Dispersion",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Measures of Dispersion.pdf?sp=r&st=2020-04-15T14:45:31Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=F0MqiFSAuMNJnLIyjaNUqF%2FbgO6DmZ08d3R8iY4%2BTBQ%3D&sr=f"
          }
        ]
      },
      {
        title: "Computer Science",
        data: [
          {
            title: "Basics of Information Technology",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Computers/Basics of Information Technology.pdf?sp=r&st=2020-04-15T14:52:11Z&se=2024-04-16T14:52:00Z&sv=2019-02-02&sig=kmd0yvOt3Tfr90T0yRfnjXafCyhmGUcwTLZqaG4k3v8%3D&sr=f"
          },
          {
            title: "Information Networks",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Computers/Information Networks.pdf?sp=r&st=2020-04-15T14:55:08Z&se=2024-04-16T14:55:00Z&sv=2019-02-02&sig=5aylnCpayyu5RRD5epYFpcNsN1QTk28ufqVSuEfcyBk%3D&sr=f"
          },
          {
            title: "Data Communication",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Computers/Data Communication.pdf?sp=r&st=2020-04-15T14:54:53Z&se=2025-04-16T14:54:00Z&sv=2019-02-02&sig=b5TxSXs%2FDpcDRS6iArxO%2BUPSrfkGJ9R%2Ffzb5E42WuL4%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Chemistry",
        data: [
          {
            title: "Stoichiometry",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Stoichiometry-FINAL.pdf?sp=r&st=2020-05-02T14:35:38Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=p0D5XtVuVS89zcoJl6NNBiogvM%2BajfqWb6WSSe4qJlo%3D&sr=f"
          },
          {
            title: "Atomic Structure",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Atomic Structure-FINAL.pdf?sp=r&st=2020-05-02T14:35:25Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=3%2Bsz8Wqn%2BDoFmO6zwawDi34tUJxUFvTx1yA7ADLUepk%3D&sr=f"
          },
          {
            title: " Theories of Covalent Bondings",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Theories of Covalent Bondings-FINAL.pdf?sp=r&st=2020-05-02T14:35:50Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=CLya%2B36%2BsdntD5edcIBAt3FX7yXceYhAMQOaWGcmo%2BE%3D&sr=f"
          }
        ]
      },
      {
        title: "Mathematics",
        data: [
          {
            title: "Matrices and Determinants",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Matrices & Determinant.pdf?sp=r&st=2020-04-14T20:24:43Z&se=2025-04-15T20:24:00Z&sv=2019-02-02&sig=UOaWrnDaLT4Ga7AaPCLTWb3PIuJgtMhXSnNq3uzCSQU%3D&sr=f"
          },
          {
            title: "Quadratic Equations",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Quadratic Equations.pdf?sp=r&st=2020-04-14T20:25:14Z&se=2026-04-15T20:25:00Z&sv=2019-02-02&sig=ZQ1pqIm3PTjyVCRKyx3eYCG98PQdl36yrzu8Y3JyFIw%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Measurements-Final.pdf?sp=r&st=2020-05-03T12:11:48Z&se=2025-05-04T12:11:00Z&sv=2019-10-10&sig=Hg%2BE7XReM1PX6UsEHWINhd7TMsS39yGwi3dCE9PQb1g%3D&sr=f"
          },
          {
            title: " Vectors and Equilibriums",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Vectors and Equilibrium-Final.pdf?sp=r&st=2020-05-03T12:12:21Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=tS23nFKMlNn91HRf0jp%2FcBg5gP8yvyPlrryHU80gtxg%3D&sr=f"
          },
          {
            title: " Motion & Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Motion & Force-Final.pdf?sp=r&st=2020-05-03T12:12:04Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=O4Ys7%2FFJI0PdramtwNujkqqvVGoYNtfX2tafWE6YNtM%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: " Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nasar-Final.pdf?sp=r&st=2020-05-03T12:26:27Z&se=2025-05-04T12:26:00Z&sv=2019-10-10&sig=ctqmtJ2ucJFROJjwVOOlVlmE47ixhcM7nFzw%2B%2Fku2l8%3D&sr=f"
          },
          {
            title: " Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nazam-Final.pdf?sp=r&st=2020-05-03T12:28:00Z&se=2026-05-04T12:28:00Z&sv=2019-10-10&sig=HaqxB4J8IzAhZ963n7%2FAe%2FmHF7h9x8FJdEAG%2Fsq%2F77Q%3D&sr=f"
          },
          {
            title: " Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Grammar-Final.pdf?sp=r&st=2020-05-03T12:28:18Z&se=2025-05-04T12:28:00Z&sv=2019-10-10&sig=iyiU5GdRjFXucw7ZFsNlr2j9kR3mT1g22AMTacZ%2BO1Q%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: " Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Lessons-Final.pdf?sp=r&st=2020-05-03T15:23:17Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=CHIMWj9TYBvl7OLdrAhFjxDuSyfRwZuai%2F3akFpist8%3D&sr=f"
          },
          {
            title: " Play",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Play-Final.pdf?sp=r&st=2020-05-03T15:23:33Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=54PYrcIYAklCyeH9zIcphLqHsdtvcLmpaGY2cboaChs%3D&sr=f"
          },
          {
            title: " Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Poems-Final.pdf?sp=r&st=2020-05-03T15:23:45Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=3Tym%2BjIc5DM4pmqwvRC5Grp5lqtuTUb2hWdg5CTZY5A%3D&sr=f"
          },
          {
            title: " Grammar and Compositions",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/EnglishGrammar-Final.pdf?sp=r&st=2020-05-03T17:50:17Z&se=2030-05-04T17:50:00Z&sv=2019-10-10&sig=t5IRp73vibvP%2FYUvsf9gQEvc1fZBZl1nLobiTLsdjGs%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Chemistry",
        data: [
          {
            title: "Stoichiometry",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Stoichiometry-FINAL.pdf?sp=r&st=2020-05-02T14:35:38Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=p0D5XtVuVS89zcoJl6NNBiogvM%2BajfqWb6WSSe4qJlo%3D&sr=f"
          },
          {
            title: "Atomic Structure",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Atomic Structure-FINAL.pdf?sp=r&st=2020-05-02T14:35:25Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=3%2Bsz8Wqn%2BDoFmO6zwawDi34tUJxUFvTx1yA7ADLUepk%3D&sr=f"
          },
          {
            title: "Theories of Covalent Bondings",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Theories of Covalent Bondings-FINAL.pdf?sp=r&st=2020-05-02T14:35:50Z&se=2026-05-03T14:35:00Z&sv=2019-10-10&sig=CLya%2B36%2BsdntD5edcIBAt3FX7yXceYhAMQOaWGcmo%2BE%3D&sr=f"
          }
        ]
      },
      {
        title: "Biology",
        data: [
          {
            title: "Cell Structure and Functions",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Cell Structure and Functions.pdf?sp=r&st=2020-05-02T14:42:13Z&se=2025-05-03T14:42:00Z&sv=2019-10-10&sig=RS%2BMF6FIUFc7NBP6a%2BNJAJ%2BecmupXS0AAWkigjhi8S0%3D&sr=f"
          },
          {
            title: "Enzymes",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Enzymes.pdf?sp=r&st=2020-05-02T14:42:26Z&se=2026-05-03T14:42:00Z&sv=2019-10-10&sig=8E1bTQyabbtX1GJtQjWZfs2vEYhF%2BrObwMcshehW4Ek%3D&sr=f"
          },
          {
            title: "A Cellular Life",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/A Cellular Life.pdf?sp=r&st=2020-05-02T14:41:22Z&se=2026-05-03T14:41:00Z&sv=2019-10-10&sig=XUOZMlXdCd4OVx4fGdV4sDEt6Jo6FSDRF3%2BoZQ8qe4E%3D&sr=f"
          },
          {
            title: "Prokaryotes",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/PROKARYOTES.pdf?sp=r&st=2020-05-02T14:42:38Z&se=2025-05-03T14:42:00Z&sv=2019-10-10&sig=9SBfy5ahExoOTDUvPA5PJnLZ0p4ZAqUD0jCWo1Abs1w%3D&sr=f"
          },
          {
            title: "Immunity",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/IMMUNITY.pdf?sp=r&st=2020-05-02T14:42:51Z&se=2025-05-03T14:42:00Z&sv=2019-10-10&sig=jnb26mqaDUitvDO81eixzyznskfOL7NLn1Fb90zJPls%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Measurements-Final.pdf?sp=r&st=2020-05-03T12:11:48Z&se=2025-05-04T12:11:00Z&sv=2019-10-10&sig=Hg%2BE7XReM1PX6UsEHWINhd7TMsS39yGwi3dCE9PQb1g%3D&sr=f"
          },
          {
            title: "Vectors and Equilibriums",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Vectors and Equilibrium-Final.pdf?sp=r&st=2020-05-03T12:12:21Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=tS23nFKMlNn91HRf0jp%2FcBg5gP8yvyPlrryHU80gtxg%3D&sr=f"
          },
          {
            title: "Motion & Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Motion & Force-Final.pdf?sp=r&st=2020-05-03T12:12:04Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=O4Ys7%2FFJI0PdramtwNujkqqvVGoYNtfX2tafWE6YNtM%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nasar-Final.pdf?sp=r&st=2020-05-03T12:26:27Z&se=2025-05-04T12:26:00Z&sv=2019-10-10&sig=ctqmtJ2ucJFROJjwVOOlVlmE47ixhcM7nFzw%2B%2Fku2l8%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nazam-Final.pdf?sp=r&st=2020-05-03T12:28:00Z&se=2026-05-04T12:28:00Z&sv=2019-10-10&sig=HaqxB4J8IzAhZ963n7%2FAe%2FmHF7h9x8FJdEAG%2Fsq%2F77Q%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Grammar-Final.pdf?sp=r&st=2020-05-03T12:28:18Z&se=2025-05-04T12:28:00Z&sv=2019-10-10&sig=iyiU5GdRjFXucw7ZFsNlr2j9kR3mT1g22AMTacZ%2BO1Q%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Lessons-Final.pdf?sp=r&st=2020-05-03T15:23:17Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=CHIMWj9TYBvl7OLdrAhFjxDuSyfRwZuai%2F3akFpist8%3D&sr=f"
          },
          {
            title: "Play",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Play-Final.pdf?sp=r&st=2020-05-03T15:23:33Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=54PYrcIYAklCyeH9zIcphLqHsdtvcLmpaGY2cboaChs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Poems-Final.pdf?sp=r&st=2020-05-03T15:23:45Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=3Tym%2BjIc5DM4pmqwvRC5Grp5lqtuTUb2hWdg5CTZY5A%3D&sr=f"
          },
          {
            title: "Grammar and Compositions",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/EnglishGrammar-Final.pdf?sp=r&st=2020-05-03T17:50:17Z&se=2030-05-04T17:50:00Z&sv=2019-10-10&sig=t5IRp73vibvP%2FYUvsf9gQEvc1fZBZl1nLobiTLsdjGs%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Business Mathematics",
        data: [
          {
            title: "Amount of Annuity",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Amount of annuity.pdf?sp=r&st=2020-04-14T21:15:14Z&se=2025-04-15T21:15:00Z&sv=2019-02-02&sig=975rk4DpwHs0gF0LceTQUeSadjlRgUY3wKaq1tXqaOY%3D&sr=f"
          },
          {
            title: "Binary Number System",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Binary number system & its operation.pdf?sp=r&st=2020-04-14T21:17:40Z&se=2024-04-15T21:17:00Z&sv=2019-02-02&sig=9HLgW3IcNs%2FylsfQt0LWlOrLRj3Ra0tjThLnh7S12H8%3D&sr=f"
          },
          {
            title: "Business Arithmetic",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Business Arithmetic.pdf?sp=r&st=2020-04-14T21:18:45Z&se=2025-04-15T21:18:00Z&sv=2019-02-02&sig=eY%2BZbRqBfM49z7KIsQOZ5fUloj3IsZKYDazxVM9EVJs%3D&sr=f"
          },
          {
            title: "Elements of Matrix Algebra",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Elements of Matrix Algebra.pdf?sp=r&st=2020-04-14T21:50:01Z&se=2025-04-15T21:50:00Z&sv=2019-02-02&sig=bnFS8I0PSc0o%2B7o7pIqtlIKJzgleDA0bfQXg9CrhfZg%3D&sr=f"
          }
        ]
      },
      {
        title: "Economics Urdu Medium",
        data: [
          {
            title: "Nature and Scope of Economics",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Nature and Scope of Economics.pdf?sp=r&st=2020-04-14T22:03:39Z&se=2025-04-15T22:03:00Z&sv=2019-02-02&sig=5kOkdl5N8%2BnrW%2FfpepiWtKK91vhWlMk9vVwKjGVBvRk%3D&sr=f"
          },
          {
            title: "Consumer Behaviour",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Consumer Behaviour.pdf?sp=r&st=2020-04-14T21:57:01Z&se=2024-04-15T21:57:00Z&sv=2019-02-02&sig=bpCtUxIi1GsYghCsdG%2BNm3GXCL4c73HHYaIlluzARzQ%3D&sr=f"
          },
          {
            title: "Demand",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Demand.pdf?sp=r&st=2020-04-14T21:57:20Z&se=2024-04-15T21:57:00Z&sv=2019-02-02&sig=rYRNCerTUr%2F9X4ki4zWdDc1QXEx0V3YfkxPesvjKq%2FY%3D&sr=f"
          },
          {
            title: "Supply",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Supply.pdf?sp=r&st=2020-04-14T22:04:41Z&se=2025-04-15T22:04:00Z&sv=2019-02-02&sig=h4ntfo2VwnVchF%2BqSpmL%2Bpz1%2BIZabDbZzklJ8ngL1Cw%3D&sr=f"
          },
          {
            title: "Market Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Market Equilibrium.pdf?sp=r&st=2020-04-14T22:03:12Z&se=2025-04-15T22:03:00Z&sv=2019-02-02&sig=cA41papfx1lD4JEXb8SLjF%2FxlQTcpRrQr7wqckwZmJg%3D&sr=f"
          },
          {
            title: "Production and Factors of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Production and Factors of Production.pdf?sp=r&st=2020-04-14T22:04:29Z&se=2025-04-15T22:04:00Z&sv=2019-02-02&sig=DWwXwtBz2siOYzusLE2wtJsLO%2Bqz1BX8oy0udrTuST4%3D&sr=f"
          },
          {
            title: "Laws of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-Laws of Production.pdf?sp=r&st=2020-04-14T21:59:50Z&se=2024-04-15T21:59:00Z&sv=2019-02-02&sig=8K7wxTJ9gQGUJz1acbDdKZG3UDBNehBoQEPNLh%2BRGkA%3D&sr=f"
          },
          {
            title: "National Income and Public Finance",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Urdu-National Income & Public Finance.pdf?sp=r&st=2020-04-14T22:03:26Z&se=2024-04-15T22:03:00Z&sv=2019-02-02&sig=fwk8scnWXjE%2BdCzECXChfKq9pRkOyg2SFIMbYiIvyHA%3D&sr=f"
          }
        ]
      },
      {
        title: "Economics English Medium",
        data: [
          {
            title: "Nature and Scope of Economics",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Nature-and-Scope-of-Economics.pdf?sp=r&st=2020-04-14T21:51:28Z&se=2024-04-15T21:51:00Z&sv=2019-02-02&sig=F8GtKqOOPGuGoTmAUnAL8IL7yAg%2BzboJSbvM9yJh%2Fjk%3D&sr=f"
          },
          {
            title: "Consumer Behaviour",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Consumer-Behaviour.pdf?sp=r&st=2020-04-14T21:49:11Z&se=2026-04-15T21:49:00Z&sv=2019-02-02&sig=MmS0biFpvPTNE1G46Sn8u1a%2Fh%2FM%2FFfsK62QEhBTVUJk%3D&sr=f"
          },
          {
            title: "Demand",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Demand.pdf?sp=r&st=2020-04-14T21:49:45Z&se=2025-04-15T21:49:00Z&sv=2019-02-02&sig=3HLXdTLOSMFCHzX8iCEkSq%2FFi%2Fi0qk7WfHoxvxvqGZ8%3D&sr=f"
          },
          {
            title: "Supply",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Supply.pdf?sp=r&st=2020-04-14T21:52:09Z&se=2025-04-15T21:52:00Z&sv=2019-02-02&sig=YePLOeGZ9hLNEBGTsJUwqtK4VprxkKlU%2FCty2N4AUHE%3D&sr=f"
          },
          {
            title: "Market Equilibrium",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Market-Equilibrium.pdf?sp=r&st=2020-04-14T21:51:03Z&se=2024-04-15T21:51:00Z&sv=2019-02-02&sig=dq6HQQ9r9%2B1%2BR0lRHxjvBeuKc56LOUnwzDWJAQXY%2BGo%3D&sr=f"
          },
          {
            title: "Production and Factors of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Production and Factors of Production.pdf?sp=r&st=2020-04-14T21:51:42Z&se=2025-04-15T21:51:00Z&sv=2019-02-02&sig=ngCZ4of5tEicKfR3mrKV%2F9ozLNYcBe3iX3LPNicD3Ik%3D&sr=f"
          },
          {
            title: "Laws of Production",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Laws of Production.pdf?sp=r&st=2020-04-14T21:50:34Z&se=2025-04-15T21:50:00Z&sv=2019-02-02&sig=X42yY%2FeOiHW807R%2BTkPSRcbcDsm8xhX42Y5ATRd1ReE%3D&sr=f"
          },
          {
            title: "National Income and Public Finance",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/National Income & Public Finance.pdf?sp=r&st=2020-04-14T21:51:15Z&se=2025-04-15T21:51:00Z&sv=2019-02-02&sig=YKmmRAYXQrWXOTx2K%2BoPYJ%2Bw9P66NSHmDTJhEXT0dGw%3D&sr=f"
          }
        ]
      },
      {
        title: "Accounting",
        data: [
          {
            title: "Introduction",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Introduction.pdf?sp=r&st=2020-04-15T13:55:52Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=H6JgdD45icDiQUc64vSaJ0bblghP4sQuqIfXNik35Bc%3D&sr=f"
          },
          {
            title: "Transactions and Accounting Equation",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Transactions.pdf?sp=r&st=2020-04-15T13:56:31Z&se=2024-04-16T13:56:00Z&sv=2019-02-02&sig=HdkpUCih3F73ZKbtkllTLDa43Pv6ZTi4Qc8Z0zw%2BSfU%3D&sr=f"
          },
          {
            title: "Analysis of Business Transactions & Double Entry System",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Double Entry.pdf?sp=r&st=2020-04-15T13:55:39Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=qERvTI%2BxnEb2Ruw0cecpff75kvg0vjw%2BvbMHWLFVxZ4%3D&sr=f"
          },
          {
            title: "Journal",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Journal.pdf?sp=r&st=2020-04-15T13:56:05Z&se=2025-04-16T13:56:00Z&sv=2019-02-02&sig=ZNhKw4t9ir8UpcKSOedPmqdPy2MmPTes7zyf57%2BP4EA%3D&sr=f"
          },
          {
            title: "Ledger",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Ledgar.pdf?sp=r&st=2020-04-15T13:56:17Z&se=2025-04-16T13:56:00Z&sv=2019-02-02&sig=M%2BSXwSu84AV5jdE3njOjmI2EIPbw2CEHf9bZPru4U9A%3D&sr=f"
          },
          {
            title: "Cash Book & Bank Reconciliation Statement",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Accounting/Accounting - Cash Book.pdf?sp=r&st=2020-04-15T13:55:24Z&se=2024-04-16T13:55:00Z&sv=2019-02-02&sig=SQ7x2bcxHq5XH4u86NRyKRyrwcqrtRRZ8snSboeEi6c%3D&sr=f"
          }
        ]
      },
      {
        title: "Commerce English Medium",
        data: [
          {
            title: "Concept of Business",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Concept of Business.pdf?sp=r&st=2020-04-15T14:33:20Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=JA7RjuKnrILDrpLgwVLgOUyVly0x0jVkG8FDkGgKD24%3D&sr=f"
          },
          {
            title: "Nature & Scope of Commerce",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Nature And Scope.pdf?sp=r&st=2020-04-15T14:33:54Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=2gsRBcifvMWvfmHNSh6WIcbKupQprVSiqiOXP8qED84%3D&sr=f"
          },
          {
            title: "Sole Tradership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Sole Tradership.pdf?sp=r&st=2020-04-15T14:34:19Z&se=2024-04-16T14:34:00Z&sv=2019-02-02&sig=o8qDWH38lA%2FvHlvzxihdOxVYKc20IMSumC%2BTpVG5JeM%3D&sr=f"
          },
          {
            title: "Partnership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Partnership.pdf?sp=r&st=2020-04-15T14:34:07Z&se=2024-04-16T14:34:00Z&sv=2019-02-02&sig=xcQD3QgAFa9C2EwUR6RsiWR1K8NJEL3oZn8Bx2K67%2BU%3D&sr=f"
          },
          {
            title: "Joint Stock Company",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Commerce -English Joint Stock Company.pdf?sp=r&st=2020-04-15T14:33:40Z&se=2024-04-16T14:33:00Z&sv=2019-02-02&sig=3tO54hUfEExlx0rXS2CxraKGyHzpW0vdTR40khUPN4M%3D&sr=f"
          },
          {
            title: "Concept of Business",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Concept of Business.pdf?sp=r&st=2020-04-15T14:35:41Z&se=2024-04-16T14:35:00Z&sv=2019-02-02&sig=R4%2BpQQxwG3FOU7KTxWKmyvkfD5siFd2S%2FikJnKZpOP4%3D&sr=f"
          },
          {
            title: "Nature & Scope of Commerce",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Nature and Scope of Commerce.pdf?sp=r&st=2020-04-15T14:36:11Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=6qV1JPCDe%2BC490GMYqKU43fl7YXb38EIZyo5NmVkjeQ%3D&sr=f"
          },
          {
            title: "Sole Tradership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Sole Tradership.pdf?sp=r&st=2020-04-15T14:36:34Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=TDw9JDr5s1DHz8aO0fearUjqto1h7pmYNpY5AqNUsbA%3D&sr=f"
          },
          {
            title: "Partnership",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Partnership.pdf?sp=r&st=2020-04-15T14:36:22Z&se=2024-04-16T14:36:00Z&sv=2019-02-02&sig=gRfT6ZlCWbGJTD0H2WrBOn3DvmPfQNVvg%2FWzYKbw1sA%3D&sr=f"
          },
          {
            title: "Joint Stock Company",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICOM/Commerce/Urdu Commerce - Joint Stock Company.pdf?sp=r&st=2020-04-15T14:35:55Z&se=2023-04-16T14:35:00Z&sv=2019-02-02&sig=Hr4HwIp3wK4N7FP4GzGtIP%2BL%2BrQ62SuQX7cygirTvxw%3D&sr=f"
          }
        ]
      },
      {
        title: "Urdu",
        data: [
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nasar-Final.pdf?sp=r&st=2020-05-03T12:26:27Z&se=2025-05-04T12:26:00Z&sv=2019-10-10&sig=ctqmtJ2ucJFROJjwVOOlVlmE47ixhcM7nFzw%2B%2Fku2l8%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nazam-Final.pdf?sp=r&st=2020-05-03T12:28:00Z&se=2026-05-04T12:28:00Z&sv=2019-10-10&sig=HaqxB4J8IzAhZ963n7%2FAe%2FmHF7h9x8FJdEAG%2Fsq%2F77Q%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Grammar-Final.pdf?sp=r&st=2020-05-03T12:28:18Z&se=2025-05-04T12:28:00Z&sv=2019-10-10&sig=iyiU5GdRjFXucw7ZFsNlr2j9kR3mT1g22AMTacZ%2BO1Q%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Lessons-Final.pdf?sp=r&st=2020-05-03T15:23:17Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=CHIMWj9TYBvl7OLdrAhFjxDuSyfRwZuai%2F3akFpist8%3D&sr=f"
          },
          {
            title: "Play",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Play-Final.pdf?sp=r&st=2020-05-03T15:23:33Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=54PYrcIYAklCyeH9zIcphLqHsdtvcLmpaGY2cboaChs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Poems-Final.pdf?sp=r&st=2020-05-03T15:23:45Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=3Tym%2BjIc5DM4pmqwvRC5Grp5lqtuTUb2hWdg5CTZY5A%3D&sr=f"
          },
          {
            title: "Grammar and Compositions",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/EnglishGrammar-Final.pdf?sp=r&st=2020-05-03T17:50:17Z&se=2030-05-04T17:50:00Z&sv=2019-10-10&sig=t5IRp73vibvP%2FYUvsf9gQEvc1fZBZl1nLobiTLsdjGs%3D&sr=f"
          }
        ]
      }
    ],
    [
      {
        title: "Mathematics",
        data: [
          {
            title: "Matrices and Determinants",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Matrices & Determinant.pdf?sp=r&st=2020-04-14T20:24:43Z&se=2025-04-15T20:24:00Z&sv=2019-02-02&sig=UOaWrnDaLT4Ga7AaPCLTWb3PIuJgtMhXSnNq3uzCSQU%3D&sr=f"
          },
          {
            title: "Quadratic Equations",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/FSC-ENGINEERING/Resources/Reading Materials/Quadratic Equations.pdf?sp=r&st=2020-04-14T20:25:14Z&se=2026-04-15T20:25:00Z&sv=2019-02-02&sig=ZQ1pqIm3PTjyVCRKyx3eYCG98PQdl36yrzu8Y3JyFIw%3D&sr=f"
          }
        ]
      },
      {
        title: "Statistics",
        data: [
          {
            title: "Introdcution",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Introduction to Statistics.pdf?sp=r&st=2020-04-15T14:45:13Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=xlvPbj8rL%2BcAtOPK%2BNstOBmnEqeqGmOo2K42bQfI1Uk%3D&sr=f"
          },
          {
            title: "Presentation of Data",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Presentation of Data.pdf?sp=r&st=2020-04-15T14:45:55Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=DOZADGT5V2Ku4xKlZlHfUnCgWq0K5OriaLTQ1eb1cYc%3D&sr=f"
          },
          {
            title: "Measures of Location",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Measures of Location.pdf?sp=r&st=2020-04-15T14:45:42Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=S7MJgt9v0bwrxx8JveqWlXXV%2B7e1c%2FkkS0ezDwfrXFc%3D&sr=f"
          },
          {
            title: "Measures of Dispersion",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/ICS/Stats/Measures of Dispersion.pdf?sp=r&st=2020-04-15T14:45:31Z&se=2024-04-16T14:45:00Z&sv=2019-02-02&sig=F0MqiFSAuMNJnLIyjaNUqF%2FbgO6DmZ08d3R8iY4%2BTBQ%3D&sr=f"
          }
        ]
      },
      {
        title: "Computer Science",
        data: [
          {
            title: "Overview of Computer System",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Overview of Computer System.pdf?sp=r&st=2020-05-02T15:01:29Z&se=2028-05-03T15:01:00Z&sv=2019-10-10&sig=Y3djPUWZGPnVBXr8V1MozhNsiaebAqbDHPb9oSUtulY%3D&sr=f"
          },
          {
            title: "Computer Memory",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Computer Memory.pdf?sp=r&st=2020-05-02T15:01:01Z&se=2027-05-03T15:01:00Z&sv=2019-10-10&sig=qKLjKA2sC3srp1SXAiDJqn8EItFU%2FBXngS9BgeFSOUM%3D&sr=f"
          },
          {
            title: "Network Communication and Protocols",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Network Communication and Protocols.pdf?sp=r&st=2020-05-02T15:01:16Z&se=2027-05-03T15:01:00Z&sv=2019-10-10&sig=wDmWNakFNaEl9EhN5Zmh6JJp8vdhU5Xg9IxQeY%2BXVcU%3D&sr=f"
          },
          {
            title: "Wireless Communications",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Wireless Communications.pdf?sp=r&st=2020-05-02T15:01:45Z&se=2027-05-03T15:01:00Z&sv=2019-10-10&sig=O%2FW3%2FGM974ruercTV1y5rDVvAHBLlqVxkUJW5Or8XJY%3D&sr=f"
          }
        ]
      },
      {
        title: "Physics",
        data: [
          {
            title: "Measurements",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Measurements-Final.pdf?sp=r&st=2020-05-03T12:11:48Z&se=2025-05-04T12:11:00Z&sv=2019-10-10&sig=Hg%2BE7XReM1PX6UsEHWINhd7TMsS39yGwi3dCE9PQb1g%3D&sr=f"
          },
          {
            title: "Vectors and Equilibriums",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Vectors and Equilibrium-Final.pdf?sp=r&st=2020-05-03T12:12:21Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=tS23nFKMlNn91HRf0jp%2FcBg5gP8yvyPlrryHU80gtxg%3D&sr=f"
          },
          {
            title: "Motion & Force",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Motion & Force-Final.pdf?sp=r&st=2020-05-03T12:12:04Z&se=2027-05-04T12:12:00Z&sv=2019-10-10&sig=O4Ys7%2FFJI0PdramtwNujkqqvVGoYNtfX2tafWE6YNtM%3D&sr=f"
          }
        ]
      },

      {
        title: "Urdu",
        data: [
          {
            title: "Nasar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nasar-Final.pdf?sp=r&st=2020-05-03T12:26:27Z&se=2025-05-04T12:26:00Z&sv=2019-10-10&sig=ctqmtJ2ucJFROJjwVOOlVlmE47ixhcM7nFzw%2B%2Fku2l8%3D&sr=f"
          },
          {
            title: "Nazam",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Nazam-Final.pdf?sp=r&st=2020-05-03T12:28:00Z&se=2026-05-04T12:28:00Z&sv=2019-10-10&sig=HaqxB4J8IzAhZ963n7%2FAe%2FmHF7h9x8FJdEAG%2Fsq%2F77Q%3D&sr=f"
          },
          {
            title: "Grammar",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Grammar-Final.pdf?sp=r&st=2020-05-03T12:28:18Z&se=2025-05-04T12:28:00Z&sv=2019-10-10&sig=iyiU5GdRjFXucw7ZFsNlr2j9kR3mT1g22AMTacZ%2BO1Q%3D&sr=f"
          }
        ]
      },
      {
        title: "English",
        data: [
          {
            title: "Lessons",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Lessons-Final.pdf?sp=r&st=2020-05-03T15:23:17Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=CHIMWj9TYBvl7OLdrAhFjxDuSyfRwZuai%2F3akFpist8%3D&sr=f"
          },
          {
            title: "Play",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Play-Final.pdf?sp=r&st=2020-05-03T15:23:33Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=54PYrcIYAklCyeH9zIcphLqHsdtvcLmpaGY2cboaChs%3D&sr=f"
          },
          {
            title: "Poems",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/Poems-Final.pdf?sp=r&st=2020-05-03T15:23:45Z&se=2026-05-04T15:23:00Z&sv=2019-10-10&sig=3Tym%2BjIc5DM4pmqwvRC5Grp5lqtuTUb2hWdg5CTZY5A%3D&sr=f"
          },
          {
            title: "Grammar and Compositions",
            download:
              "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Reading Materials/EnglishGrammar-Final.pdf?sp=r&st=2020-05-03T17:50:17Z&se=2030-05-04T17:50:00Z&sv=2019-10-10&sig=t5IRp73vibvP%2FYUvsf9gQEvc1fZBZl1nLobiTLsdjGs%3D&sr=f"
          }
        ]
      }
    ]
  ];

  private syllabuses = [
    [
      {
        title: "Chemistry",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Chemistry.pdf?sp=r&st=2020-04-14T22:25:07Z&se=2024-04-15T22:25:00Z&sv=2019-02-02&sig=VdOHGP%2BfSIUKqIkmI5wdt3szDSaJETWDWKiEzmMSDdw%3D&sr=f"
      },
      {
        title: "Maths",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Mathematics.pdf?sp=r&st=2020-04-14T22:26:35Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=lsW%2FQ32YLZFSDoRQAciTii6kmjMXBpRHLta2Etkbe1c%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Physics.pdf?sp=r&st=2020-04-14T22:26:56Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=KQfFxvArgtHhHfyeGicQrX2i3V3LmPmvyWJqvROGK%2F0%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Urdu.pdf?sp=r&st=2020-04-14T22:27:32Z&se=2024-04-15T22:27:00Z&sv=2019-02-02&sig=7%2FPy%2BxLY%2BccGy2DrdKBmRR6T84X6WQgoa9GQy4BY%2FgE%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/English.pdf?sp=r&st=2020-04-14T22:26:16Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=ehaMU4bmSSo2mD1oVu02HQFywcu1mYb1caaYrLXplOc%3D&sr=f"
      }
    ],
    [
      {
        title: "Chemistry",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Chemistry.pdf?sp=r&st=2020-04-14T22:25:07Z&se=2024-04-15T22:25:00Z&sv=2019-02-02&sig=VdOHGP%2BfSIUKqIkmI5wdt3szDSaJETWDWKiEzmMSDdw%3D&sr=f"
      },
      {
        title: "Biology",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Biology.pdf?sp=r&st=2020-04-14T22:24:35Z&se=2025-04-15T22:24:00Z&sv=2019-02-02&sig=3W9jjjhjR76kBpQm%2FtSVRBLTRKDft8IkqaQs91XUuu8%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Physics.pdf?sp=r&st=2020-04-14T22:26:56Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=KQfFxvArgtHhHfyeGicQrX2i3V3LmPmvyWJqvROGK%2F0%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Urdu.pdf?sp=r&st=2020-04-14T22:27:32Z&se=2024-04-15T22:27:00Z&sv=2019-02-02&sig=7%2FPy%2BxLY%2BccGy2DrdKBmRR6T84X6WQgoa9GQy4BY%2FgE%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/English.pdf?sp=r&st=2020-04-14T22:26:16Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=ehaMU4bmSSo2mD1oVu02HQFywcu1mYb1caaYrLXplOc%3D&sr=f"
      }
    ],
    [
      {
        title: "Accounting",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Accounting.pdf?sp=r&st=2020-04-14T22:24:08Z&se=2025-04-15T22:24:00Z&sv=2019-02-02&sig=IC1DPee%2FCijFj87U60JqTRW3Vdt0GGjwdul7eeQIXzM%3D&sr=f"
      },
      {
        title: "Commerce",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Commerce.pdf?sp=r&st=2020-04-14T22:25:24Z&se=2025-04-15T22:25:00Z&sv=2019-02-02&sig=N57R6rZJrS26XhsgRM0oaFj%2B9%2FmPnylC6G9R1avA280%3D&sr=f"
      },
      {
        title: "Economics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Economics.pdf?sp=r&st=2020-04-14T22:25:59Z&se=2025-04-15T22:25:00Z&sv=2019-02-02&sig=f6uHfNlW%2BghOqYGg0Yrpfk3qu0da89xUE%2BlE7c4EP8s%3D&sr=f"
      },
      {
        title: "Business Mathematics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Business Mathematics.pdf?sp=r&st=2020-04-14T22:24:52Z&se=2025-04-15T22:24:00Z&sv=2019-02-02&sig=eW5AV02embBJVVlUd6Nrkwy%2BH1tuztW96%2Fwp2P3mIg8%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Urdu.pdf?sp=r&st=2020-04-14T22:27:32Z&se=2024-04-15T22:27:00Z&sv=2019-02-02&sig=7%2FPy%2BxLY%2BccGy2DrdKBmRR6T84X6WQgoa9GQy4BY%2FgE%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/English.pdf?sp=r&st=2020-04-14T22:26:16Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=ehaMU4bmSSo2mD1oVu02HQFywcu1mYb1caaYrLXplOc%3D&sr=f"
      }
    ],
    [
      {
        title: "Statistics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Statistics.pdf?sp=r&st=2020-04-14T22:27:19Z&se=2024-04-15T22:27:00Z&sv=2019-02-02&sig=v5%2FqkbX13rwP1Rw93hdKVMbXkE%2BycrE6Be2LY3JLLZI%3D&sr=f"
      },
      {
        title: "Maths",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Mathematics.pdf?sp=r&st=2020-04-14T22:26:35Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=lsW%2FQ32YLZFSDoRQAciTii6kmjMXBpRHLta2Etkbe1c%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Physics.pdf?sp=r&st=2020-04-14T22:26:56Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=KQfFxvArgtHhHfyeGicQrX2i3V3LmPmvyWJqvROGK%2F0%3D&sr=f"
      },
      {
        title: "Computers",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Computer.pdf?sp=r&st=2020-04-14T22:25:41Z&se=2026-04-15T22:25:00Z&sv=2019-02-02&sig=w%2Beq4vl96gTaeihCIti44ee1WDBOIolVr%2Blb4h6CqP8%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Urdu.pdf?sp=r&st=2020-04-14T22:27:32Z&se=2024-04-15T22:27:00Z&sv=2019-02-02&sig=7%2FPy%2BxLY%2BccGy2DrdKBmRR6T84X6WQgoa9GQy4BY%2FgE%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/English.pdf?sp=r&st=2020-04-14T22:26:16Z&se=2024-04-15T22:26:00Z&sv=2019-02-02&sig=ehaMU4bmSSo2mD1oVu02HQFywcu1mYb1caaYrLXplOc%3D&sr=f"
      }
    ],
    [
      {
        title: "Mathematics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Mathematics.pdf?sp=r&st=2020-05-02T12:45:30Z&se=2031-05-03T12:45:00Z&sv=2019-10-10&sig=GWpkL1dex4F7e%2BOWRWCo9S4CS6fQ6uUFjMMgpzfjWtY%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Physics.pdf?sp=r&st=2020-05-02T12:46:06Z&se=2027-05-03T12:46:00Z&sv=2019-10-10&sig=E532xsoQS5ab%2FlXRJ96CvMq%2BTa%2BQtKCUDRhcRUQFVx8%3D&sr=f"
      },
      {
        title: "Chemistry",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Chemistry.pdf?sp=r&st=2020-05-02T12:55:09Z&se=2030-05-03T12:55:00Z&sv=2019-10-10&sig=tQY%2BQN2ZSu%2BC6CQQTpsAoMYg13MWL16OblZ35ouLlKA%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Urdu.pdf?sp=r&st=2020-05-02T12:29:50Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=tsDqPXF5DcElNxHagtcFrhlPmw3SM2CT60awQe5BysM%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/English.pdf?sp=r&st=2020-05-02T12:30:04Z&se=2027-05-03T12:30:00Z&sv=2019-10-10&sig=wpkx2ilO6yQhO%2BwFB%2Fsoa0hGx2DXu1fqUSfvykmC8hg%3D&sr=f"
      }
    ],
    [
      {
        title: "Biology",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Biology.pdf?sp=r&st=2020-05-02T12:54:54Z&se=2028-05-03T12:54:00Z&sv=2019-10-10&sig=0iuXAOfjzyzjsz7hG22qYWp58yZu%2Fi6SFnexVy%2FfWv8%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Physics.pdf?sp=r&st=2020-05-02T12:46:06Z&se=2027-05-03T12:46:00Z&sv=2019-10-10&sig=E532xsoQS5ab%2FlXRJ96CvMq%2BTa%2BQtKCUDRhcRUQFVx8%3D&sr=f"
      },
      {
        title: "Chemistry",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Chemistry.pdf?sp=r&st=2020-05-02T12:55:09Z&se=2030-05-03T12:55:00Z&sv=2019-10-10&sig=tQY%2BQN2ZSu%2BC6CQQTpsAoMYg13MWL16OblZ35ouLlKA%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Urdu.pdf?sp=r&st=2020-05-02T12:29:50Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=tsDqPXF5DcElNxHagtcFrhlPmw3SM2CT60awQe5BysM%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/English.pdf?sp=r&st=2020-05-02T12:30:04Z&se=2027-05-03T12:30:00Z&sv=2019-10-10&sig=wpkx2ilO6yQhO%2BwFB%2Fsoa0hGx2DXu1fqUSfvykmC8hg%3D&sr=f"
      }
    ],
    [
      {
        title: "Accounting",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Accounting.pdf?sp=r&st=2020-05-02T12:28:08Z&se=2026-05-03T12:28:00Z&sv=2019-10-10&sig=fP%2FHehLTKeG1x40QbT7eCYZVDdvCnft3BhIBxdFnaqg%3D&sr=f"
      },
      {
        title: "Commerce",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Commerce.pdf?sp=r&st=2020-05-02T12:28:24Z&se=2026-05-03T12:28:00Z&sv=2019-10-10&sig=BheLxAbmKYNbCSi3%2Fnlc1JwfGZL9NqHWhySq%2BrdMuDI%3D&sr=f"
      },
      {
        title: "Economics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Economics.pdf?sp=r&st=2020-05-02T12:29:10Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=OIcgnOLyPrJrcNkitT7YUGh8vnp6cO5BfvZFCESLh40%3D&sr=f"
      },
      {
        title: "Business Mathematics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Bus. Maths.pdf?sp=r&st=2020-05-02T12:29:31Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=cqMfnJ1%2B0oCl8EkIW0aFhn9gF0N%2BTG8pukKvTGCC2lU%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Urdu.pdf?sp=r&st=2020-05-02T12:29:50Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=tsDqPXF5DcElNxHagtcFrhlPmw3SM2CT60awQe5BysM%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/English.pdf?sp=r&st=2020-05-02T12:30:04Z&se=2027-05-03T12:30:00Z&sv=2019-10-10&sig=wpkx2ilO6yQhO%2BwFB%2Fsoa0hGx2DXu1fqUSfvykmC8hg%3D&sr=f"
      }
    ],
    [
      {
        title: "Statistics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Statistics.pdf?sp=r&st=2020-05-02T12:46:24Z&se=2027-05-03T12:46:00Z&sv=2019-10-10&sig=Sqqttn3GdTcWdzcxDd5Ekg%2BNMV25Aar5%2FgJ0MVmqzAM%3D&sr=f"
      },
      {
        title: "Physics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Physics.pdf?sp=r&st=2020-05-02T12:46:06Z&se=2027-05-03T12:46:00Z&sv=2019-10-10&sig=E532xsoQS5ab%2FlXRJ96CvMq%2BTa%2BQtKCUDRhcRUQFVx8%3D&sr=f"
      },
      {
        title: "Computers",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Computer.pdf?sp=r&st=2020-05-02T12:45:52Z&se=2026-05-03T12:45:00Z&sv=2019-10-10&sig=htHX8N5vWFTehpCwCFM%2FL5v%2FmK9YM9R1E2R9FcryqAs%3D&sr=f"
      },
      {
        title: "Mathematics",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Mathematics.pdf?sp=r&st=2020-05-02T12:45:30Z&se=2031-05-03T12:45:00Z&sv=2019-10-10&sig=GWpkL1dex4F7e%2BOWRWCo9S4CS6fQ6uUFjMMgpzfjWtY%3D&sr=f"
      },
      {
        title: "Urdu",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/Urdu.pdf?sp=r&st=2020-05-02T12:29:50Z&se=2027-05-03T12:29:00Z&sv=2019-10-10&sig=tsDqPXF5DcElNxHagtcFrhlPmw3SM2CT60awQe5BysM%3D&sr=f"
      },
      {
        title: "English",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Syllabus/English.pdf?sp=r&st=2020-05-02T12:30:04Z&se=2027-05-03T12:30:00Z&sv=2019-10-10&sig=wpkx2ilO6yQhO%2BwFB%2Fsoa0hGx2DXu1fqUSfvykmC8hg%3D&sr=f"
      }
    ]
  ];

  private markup = [
    [
      {
        title: "Comprehensive Test",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/1st Test Marks Breakup/FSC.pdf?sp=r&st=2020-04-30T09:40:56Z&se=2028-05-01T09:40:00Z&sv=2019-10-10&sig=FLEaGsg539ntYQ%2FLNBM4T5DsP1qERLGltd%2FwhWd1VbQ%3D&sr=f"
      }
    ],
    [
      {
        title: "Comprehensive Test",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/1st Test Marks Breakup/FSC.pdf?sp=r&st=2020-04-30T09:40:56Z&se=2028-05-01T09:40:00Z&sv=2019-10-10&sig=FLEaGsg539ntYQ%2FLNBM4T5DsP1qERLGltd%2FwhWd1VbQ%3D&sr=f"
      }
    ],
    [
      {
        title: "Comprehensive Test",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/1st Test Marks Breakup/ICOM.pdf?sp=r&st=2020-04-30T09:41:53Z&se=2028-05-01T09:41:00Z&sv=2019-10-10&sig=Jmgf9tNomXaEFG40EoR51Kyp2x4nfjvVEUvnpBW1OL0%3D&sr=f"
      }
    ],
    [
      {
        title: "Comprehensive Test",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/1st Test Marks Breakup/ICS.pdf?sp=r&st=2020-04-30T09:42:07Z&se=2025-05-01T09:42:00Z&sv=2019-10-10&sig=WYPkkUUssyvU4ycHIT5GpnHSFYJ1VTWAXY%2ByeV0E%2BF8%3D&sr=f"
      }
    ]
  ];

  private timetables = [
    [
      {
        title: "Pre Engineering Timetable",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/Fsc Engineering.pdf?sp=r&st=2020-04-14T22:35:05Z&se=2026-04-15T22:35:00Z&sv=2019-02-02&sig=%2Fd2ry0mOrYRep%2FJv8zGcnYAVML69ut3IeDDbc%2Bb64VI%3D&sr=f"
      },
      {
        title: "Pre Engineering Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Test Schedule/Pre-Engineering Test Schedule.pdf?sp=r&st=2020-04-14T22:50:22Z&se=2025-04-15T22:50:00Z&sv=2019-02-02&sig=sBZwb9XKnxNRAse0qZ%2Fcru3KZdrCD1Z2LRjpZa22%2FV8%3D&sr=f"
      },
      {
        title: "Entry Test Session Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Entry Test for Pre-1st Year 2020.pdf?sp=r&st=2020-04-16T07:45:08Z&se=2025-04-17T07:45:00Z&sv=2019-02-02&sig=Xuf8EOjWGygpBD2twLmtGxsIoCH0jTRP1SKy%2BQk1Kso%3D&sr=f"
      }
    ],
    [
      {
        title: "Pre Medical Timetable",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/Fsc Medical.pdf?sp=r&st=2020-04-14T22:35:45Z&se=2024-04-15T22:35:00Z&sv=2019-02-02&sig=Pj1y5Emc7SBowdSwuRYIF3XDd4FUoaZeJN2GnwrTqPU%3D&sr=f"
      },
      {
        title: "Pre Medical Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Test Schedule/Medical Test Schedule.pdf?sp=r&st=2020-04-14T22:49:11Z&se=2025-04-15T22:49:00Z&sv=2019-02-02&sig=30NX2gfUUypkIMJ3i8JBoVW4wuL9zzkgqwLX7UqWLGs%3D&sr=f"
      },
      {
        title: "Entry Test Session Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Entry Test for Pre-1st Year 2020.pdf?sp=r&st=2020-04-16T07:45:08Z&se=2025-04-17T07:45:00Z&sv=2019-02-02&sig=Xuf8EOjWGygpBD2twLmtGxsIoCH0jTRP1SKy%2BQk1Kso%3D&sr=f"
      }
    ],
    [
      {
        title: "I.Com Timetable",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/ICOM.pdf?sp=r&st=2020-04-14T22:36:08Z&se=2025-04-15T22:36:00Z&sv=2019-02-02&sig=VIfRCGchRyAJ0dJ%2FeoChQXtNG8VS269twZE0lT0aqoY%3D&sr=f"
      },
      {
        title: "I.Com Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Test Schedule/I.COM Test Schedule.pdf?sp=r&st=2020-04-14T22:47:20Z&se=2026-04-15T22:47:00Z&sv=2019-02-02&sig=XyYKa0gTI48uovR4Hotbi6doCo85dwYy%2BevpeHvgmLM%3D&sr=f"
      }
    ],
    [
      {
        title: "ICS Timetable",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/ICS.pdf?sp=r&st=2020-04-14T22:36:59Z&se=2026-04-15T22:36:00Z&sv=2019-02-02&sig=ZlpFVmcWAUS0K62PLOubyECARH7Maf813iB%2BCUvsUTk%3D&sr=f"
      },
      {
        title: "ICS Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Test Schedule/ICS Test Schedule.pdf?sp=r&st=2020-04-14T22:48:54Z&se=2025-04-15T22:48:00Z&sv=2019-02-02&sig=AITwVC2zL7Q%2BE8nq2c%2BTzeM7bADxw3RJ9XZlj%2BoJLYw%3D&sr=f"
      },
      {
        title: "Entry Test Session Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Entry Test for Pre-1st Year 2020.pdf?sp=r&st=2020-04-16T07:45:08Z&se=2025-04-17T07:45:00Z&sv=2019-02-02&sig=Xuf8EOjWGygpBD2twLmtGxsIoCH0jTRP1SKy%2BQk1Kso%3D&sr=f"
      }
    ],
    [
      {
        title: "Pre Engineering Timetable",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/Fsc Engineering.pdf?sp=r&st=2020-04-14T22:35:05Z&se=2026-04-15T22:35:00Z&sv=2019-02-02&sig=%2Fd2ry0mOrYRep%2FJv8zGcnYAVML69ut3IeDDbc%2Bb64VI%3D&sr=f"
      },
      {
        title: "Pre Engineering Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/PreEngineering-TestSchedule.pdf?sp=r&st=2020-05-03T13:05:25Z&se=2028-05-04T13:05:00Z&sv=2019-10-10&sig=wrU51Pt2ai5gtmd9%2FW7Gb22OoQ4U%2FXtK%2FLHqarfsEAQ%3D&sr=f"
      },
      {
        title: "Pre Engineering Entry Test Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/EntryTestSchedule.pdf?sp=r&st=2020-05-03T13:07:48Z&se=2027-05-04T13:07:00Z&sv=2019-10-10&sig=Cc80TaUVDlu%2FgaxBdCBhrpZwuK3J8gdt4FkyAoQuvFg%3D&sr=f"
      }
    ],
    [
      {
        title: "Pre Medical Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/PreMed-TestSchedule.pdf?sp=r&st=2020-05-03T13:18:20Z&se=2027-05-04T13:18:00Z&sv=2019-10-10&sig=cTmaOxhk%2FypJ51Ek6soJsfdKrBszYJQSepAkjG5kc88%3D&sr=f"
      },
      {
        title: "Pre Medical Entry Test Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/EntryTestSchedule.pdf?sp=r&st=2020-05-03T13:07:48Z&se=2027-05-04T13:07:00Z&sv=2019-10-10&sig=Cc80TaUVDlu%2FgaxBdCBhrpZwuK3J8gdt4FkyAoQuvFg%3D&sr=f"
      },
      {
        title: "Pre Medical Timetable",
        download:
        "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/Fsc Medical.pdf?sp=r&st=2020-04-14T22:35:45Z&se=2024-04-15T22:35:00Z&sv=2019-02-02&sig=Pj1y5Emc7SBowdSwuRYIF3XDd4FUoaZeJN2GnwrTqPU%3D&sr=f"
      }
    ],
    [
      {
        title: "ICOM Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/ICOM-TestSchedule.pdf?sp=r&st=2020-05-03T13:23:32Z&se=2027-05-04T13:23:00Z&sv=2019-10-10&sig=IJCoW26waXfq2yJo92UtFFqJEimcUdigzyqaJ62ZihE%3D&sr=f"
      },
      {
        title: "ICOM Timetable",
        download:
         "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/ICOM.pdf?sp=r&st=2020-04-14T22:36:08Z&se=2025-04-15T22:36:00Z&sv=2019-02-02&sig=VIfRCGchRyAJ0dJ%2FeoChQXtNG8VS269twZE0lT0aqoY%3D&sr=f"
      }
    ],
    [
      {
        title: "ICS Entry Test Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/EntryTestSchedule.pdf?sp=r&st=2020-05-03T13:07:48Z&se=2027-05-04T13:07:00Z&sv=2019-10-10&sig=Cc80TaUVDlu%2FgaxBdCBhrpZwuK3J8gdt4FkyAoQuvFg%3D&sr=f"
      },
      {
        title: "ICS Exam Schedule",
        download:
          "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/2nd Batch and Federal/Other Resources/ICS-TestSchedule.pdf?sp=r&st=2020-05-03T13:22:01Z&se=2028-05-04T13:22:00Z&sv=2019-10-10&sig=kpJgADtMK4MVXnmiFqr9QsDLG09eLGfvSXo0R0XwPdU%3D&sr=f"
      },
      {
        title: "ICS Timetable",
        download:
        "https://elfileshare.file.core.windows.net/pgcelfiles/Pre-1st-Year/Other Resources/Timetable/ICS.pdf?sp=r&st=2020-04-14T22:36:59Z&se=2026-04-15T22:36:00Z&sv=2019-02-02&sig=ZlpFVmcWAUS0K62PLOubyECARH7Maf813iB%2BCUvsUTk%3D&sr=f"
      }
    ]
  ];
}
